import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { forgotpassword } from '../../services/authService';
import './Login.css';
import ReCAPTCHA from "react-google-recaptcha";
import { JS_CSS_IMG_VERSION, PROJECT_DISPLAY_NAME } from '../../config/apiConfig';
//6LdrhAwqAAAAAGG8IdTF7Y1cYyH3tA4aMkzWli0f - ReCaptcha Key
// import 'font-awesome/4.5.0/css/font-awesome.min.css';
// import 'fonts.googleapis.com.css.css';
{/* <link rel="stylesheet" href="font-awesome/4.5.0/css/font-awesome.min.css"/>;
<link rel="stylesheet" href="fonts.googleapis.com.css.css"/> */}


const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success_message, setSuccessMessage] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [recap, setRecap] = useState('')
  const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
 
  const validateEmail = () => {   
   if(email.match(isValidEmail)){      
      setError(); 
      // console.log(email);  
    return true;     
   }else{
    setError("Please enter a valid email address.");
     return false;
   }   
 }
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if(validateEmail()) {
            if(recap) { 
               setLoading(true);
               setRecap();       
            let my_data = await forgotpassword(email);             
               if(my_data.status == 200) {
                  
                  setError();
                     //setSuccessMessage(my_data.result.message);
                     localStorage.setItem('forgotemail', email);
                     setSuccessMessage('A password reset link has been sent to your registered email address. Please check your inbox.');
                     
                  } else { 
                     //setError(my_data.result.message);
                     setError("Emailid not found.");
                     setSuccessMessage();
                     setRecap(recap);
                     setLoading(false);    
                  }
               } else {
                  setError("Please Select ReCAPTCHA Box");
                  setSuccessMessage(); 
               }
               
            } else {
               setError("Please enter a valid email address.");
            }

   } catch (err) {
      setError(err.message || 'Emailid Not found');
    }
  };


  return (
    <div>
    <div className="main-container">
       <div className="main-content">
       <div className="login_page_wrapper">
       <div className="sub_wrapper">

          <div className="row">
              {/* <div className="col-md-7 pr-0 same_height_block pl-0">
                <div className="login_left_block">
                      <div className="login_new">
                        <div className="row logo">
                            <div className="cell">
                              <div className="login_account_logo custom_row">
                                  <div className="cell">
                                    <img src={`/img/mnm_logo_inner.png?version=${JS_CSS_IMG_VERSION}`} alt="logo" width="140" className="logo_login" />
                                  </div>
                              </div>
                            </div>
                        </div>
                        <div className="row middle_content">
                            <div className="cell">
                              <div className="login_content custom_row">
                                  <h5 className="login_subhead">Unlock the Power of Client Insights and Supercharge Your Sales with {PROJECT_DISPLAY_NAME}!</h5>
                                  <p className="login_para">Get a 360° view of your clients, uncover untapped opportunities, and create unstoppable sales pipelines—all with our ultimate sales intelligence platform.</p>
                                  <div className="login_list">
                                    <div className="login_li">
                                      <img src="/img/3x.png" className="img_icon"/>
                                      <p className="login_li_span">Faster Account Research:</p>  
                                      <p className="login_li_para">Optimize your sales preparation with AI-powered insights, saving you valuable weekly hours on client analysis.</p>
                                    </div>
                                    <div className="login_li">
                                      <img src="/img/rates.png" className="img_icon"/>
                                      <p className="login_li_span">Boost Pipeline Growth by 40%:</p>  
                                      <p className="login_li_para">Discover new buying centers and unlock opportunities that drive your sales targets.</p>
                                    </div>
                                    <div className="login_li">
                                      <img src="/img/boost.png" className="img_icon"/>
                                      <p className="login_li_span">Increase Win Rates by 25%:</p>  
                                      <p className="login_li_para">Leverage tailored talk tracks and actionable strategies to close deals confidently.</p>
                                    </div>
                                  </div>
                              </div>
                            </div>
                        </div>
                        <div className="row base">
                            <div className="cell">
                              <div className="login_bottom_mail custom_row">
                                  <div className="cell">
                                    <div className="d-flexn">
                                      <div className="email_block_left">
                                        <a target="_blank" href="https://www.marketsandmarkets.com" className="link_mail"><i className="fa fa-globe mr-2" aria-hidden="true"></i> <span className='url_email'> www.marketsandmarkets.com </span> </a>
                                      </div>
                                      <div className="email_block">
                                        <a href="mailto:salesiq@marketsandmarkets.com" className="link_mail"><i className="fa fa-envelope-open mr-2" aria-hidden="true"></i> <span className='url_email'> salesiq@marketsandmarkets.com</span> </a>
                                      </div>
                                    </div>
                                  </div>
                              </div>
                            </div>
                        </div>
                      </div>
                  </div>
              </div> */}
              <div className="col-md-5 pl-0 same_height_right" style={{margin: "0 auto"}}>
                <div className="login_right_block">
                  <div className="login_block forgot_password">
                    <div className="login_top_icon">
                     <img src="/img/login/forgot_password.png" alt="logo" width="50" className="login_icon" />
                  </div>
                  <h5 className="login_head">Forgot Password</h5>
                  <p className="login_para">We'll send a password reset link via email. If you don’t see it, check your spam folder.</p>
                  <div className="main_form_login">

                  {error && 
                   <div className="alert alert-danger">{error}</div>
                   }
                   {success_message && 
                   <div className="mb-3">
                        <div className="alert alert-success">{success_message}</div>
                        <div className='forgot_block'>
                        <span className='forgot_span'>Remember password ?<a href="/login" className="forgot_password"> Login</a></span>
                        </div>
                   </div>
                   } 
                   {!success_message && 
                   <form onSubmit={handleSubmit}>
                     {/* <div className='mb-3 login_para'>Enter the email address associated with your account</div> */}
                      <div className="mb-3">
                         <label htmlFor="email" className="form-label custom_label">Email </label>
                         <span className="block input-icon input-icon-right">
                         <input
                            type="email"
                            className="form-control custom_form_control"
                            id="email"
                            placeholder="Please enter your Email Address"
                            autoComplete='off'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)} 
                            onBlur={validateEmail}
                         required/>
                         </span>
                      </div> 
                      <div className='mb-3'>
                        <ReCAPTCHA 
                        sitekey='6LdrhAwqAAAAAGG8IdTF7Y1cYyH3tA4aMkzWli0f'
                        onChange={(val => setRecap(val)) }/>
                        </div>                    
                     
                      <div className="space-6"></div>
                      <button disabled={!recap} type="submit" className="btn btn-primary custom_log_btn w-100"> {loading ? <i className="fa fa-spinner fa-spin"></i> : <i className="fa fa-key1"></i>}
                      {' '}Submit</button>
                      <div className="forgot_block">
                            <span className='forgot_span'>Remember password ?<a href="/login" className="forgot_password"> Login</a></span>
                         </div>
                   </form> }
                  </div>
                  </div>
                </div>
              </div>
          </div>
          </div>

        </div>
          {/* <div className="row">
             <div className="col-sm-12">
                <div className="login-container">
                   <div className="center">
                      <h4 className="blue" id="id-company-text">
                         <img src="/img/mnm_logo_inner.png" width="200"/>
                      </h4>
                   </div>
                   <div className="space-4"></div>

                   <h2 className="login_head header blue"> 
                    <i className="ace-icon fa fa-sign-in blue mr-2"></i>Forgot Password                    </h2>
                   <div className="space-6"></div>

                   {error && 
                   <div className="alert alert-danger">{error}</div>
                   }
                   {success_message && 
                   <div className="alert alert-success">{success_message}</div>
                   } 
                   {!success_message && 
                   <form onSubmit={handleSubmit}>
                     <div className='mb-3'>Enter the email address associated with your account</div>
                      <div className="mb-3">
                         <label htmlFor="email" className="form-label custom_label">Email Address</label>
                         <span className="block input-icon input-icon-right">
                         <input
                            type="email"
                            className="form-control custom_form_control"
                            id="email"
                            placeholder="Please enter your Email Address"
                            autoComplete='off'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)} 
                            onBlur={validateEmail}
                         required/>
                         <i className="ace-icon fa fa-user"></i>
                         </span>
                      </div> 
                      <div className='mb-3'>
                        <ReCAPTCHA 
                        sitekey='6LdrhAwqAAAAAGG8IdTF7Y1cYyH3tA4aMkzWli0f'
                        onChange={(val => setRecap(val)) }/>
                        </div>                    
                        <div className="">
                    <a href="/login" className="forgot_password">Back To Login</a>
                  </div>
                      <div className="space-6"></div>
                      <button disabled={!recap} type="submit" className="btn btn-primary custom_login_btn width-35 pull-right"> {loading ? <i className="fa fa-spinner fa-spin"></i> : <i className="fa fa-key"></i>}
                      {' '}Submit</button>
                   </form> }
                </div>
             </div>
          </div> */}
       </div>
    </div>
 </div>
  );
};

export default ForgotPassword;
